import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const createStoreProductAsync = createAsyncThunk(
  "admin/createStoreProduct",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/store/createStoreProduct`,
      payload,
      toolkit,
    );
  },
);

export const updateStoreProductAsync = createAsyncThunk(
  "admin/updateStoreProduct",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/store/updateStoreProduct`,
      payload,
      toolkit,
    );
  },
);

export const updateStoreInventoryAsync = createAsyncThunk(
  "admin/updateStoreInventory",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/store/increaseInventory`,
      payload,
      toolkit,
    );
  },
);

export const decreaseStoreInventoryAsync = createAsyncThunk(
  "admin/decreaseInventory",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/store/decreaseInventory`,
      payload,
      toolkit,
    );
  },
);

export const updateStoreProductStatusAsync = createAsyncThunk(
  "admin/updateStoreProductStatus",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/store/updateStoreProductStatus`,
      payload,
      toolkit,
    );
  },
);

export const spokenEnglishPackagesAsync = createAsyncThunk(
  "admin/spokenEnglishPackages",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/spokenEnglishPackages?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}`,
      [],
      toolkit,
    );
  },
);

export const getAllStoreProductsAsync = createAsyncThunk(
  "admin/getAllStoreProducts",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/store/getAllStoreProducts?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}&status=${payload.status ?? ""}`,
      [],
      toolkit,
    );
  },
);

export const goalWiseCoursePackagesAsync = createAsyncThunk(
  "admin/goalWiseCoursePackages",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/goalWiseCoursePackages?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&goalId=${payload.goalId || ""}`,
      [],
      toolkit,
    );
  },
);

export const getCoursePackagesAsync = createAsyncThunk(
  "admin/getCoursePackages",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getCoursePackages?batchId=${payload.batchId || ""}`,
      [],
      toolkit,
    );
  },
);

export const getStoreProductByIdAsync = createAsyncThunk(
  "admin/getStoreProductById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/store/getStoreProductById/${payload.id}`,
      [],
      toolkit,
    );
  },
);

export const deleteStoreProductAsync = createAsyncThunk(
  "admin/deleteStoreProduct",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/store/deleteStoreProduct/${payload?.id}`,
      [],
      toolkit,
    );
  },
);

export const getAllStoreOrdersAsync = createAsyncThunk(
  "admin/getAllStoreOrders",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/store/getAllStoreOrders?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&startDate=${encodeURIComponent(payload.startDate || "")}&endDate=${encodeURIComponent(
        payload.endDate || "",
      )}`,
      [],
      toolkit,
    );
  },
);

export const storeOrderDetailsAsync = createAsyncThunk(
  "admin/storeOrderDetails",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/store/storeOrderDetails?order_id=${payload?.orderId}`,
      [],
      toolkit,
    );
  },
);

export const updateOrderStatusAsync = createAsyncThunk(
  "admin/updateOrderStatus",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/store/updateOrderStatus`,
      payload,
      toolkit,
    );
  },
);
